import React from 'react';

export default function Page404() {
    return (
        <div className="c-page-404">
            <h1>404: page not found</h1>
        </div>
    );
}